export default __webpack_public_path__ + "static/media/succulent4-big.9a86d908.jpg";